module.exports = __webpack_public_path__ + "static/media/banner-watch.4cca14ba.jpg";